<template>
	<div :class="'row ' + cls">
		<div class="col-md-12 col-xs-12 color" style="font-size: 14px">
			<span
				v-if="_escondeMobile()"
				class="label label-info pull-right no-print"
				style="margin-top: 3px"
				v-show="msg != null"
			>
				<i class="fa fa-info-circle"></i> {{ msg }}
			</span>

			<div style="display: flex">
				<p style="margin-top: 0px" v-html="texto"></p>
			</div>

			<hr class="border-color" style="margin-top: 2px; margin-bottom: 10px" />
		</div>
	</div>
</template>

<script>
export default {
	props: ['msg', 'color', 'texto', 'cls']
}
let print = false
</script>

<style scoped>
.color {
	color: #2196f3;
}

.border-color {
	border-color: #2196f3;
}
</style>
